import { render, staticRenderFns } from "./CoursesTable.vue?vue&type=template&id=7fe6f2fa&"
import script from "./CoursesTable.vue?vue&type=script&lang=js&"
export * from "./CoursesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports